import { useEffect } from "react";

export function useVisitorTracking() {
  useEffect(() => {
    if (sessionStorage.getItem("visitor_tracked")) return;

    const params = new URLSearchParams(window.location.search);
    const source = params.get("utm_source") || "";

    const payload = {
      page: window.location.pathname + window.location.hash,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      utmSource: source,
      utmMedium: params.get("utm_medium") || "",
      utmCampaign: params.get("utm_campaign") || "",
    };

    // Clean tracking params from URL so visitor sees a clean address bar
    if (source || params.get("utm_medium") || params.get("utm_campaign")) {
      window.history.replaceState(null, "", window.location.pathname);
    }

    fetch("/api/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});

    sessionStorage.setItem("visitor_tracked", "true");
  }, []);
}
